import React from 'react';
import { isVisit, isGenericEvent } from '@utils/typeGuards/scheduler-event-typeguard';
import useEventContext from '@features/MapScheduler/Scheduler/scheduler-only-hooks/use-event-context';
import EventVisit from './EventVisit';
import EventTimeOff from './EventTimeOff';
import EventGeneric from './EventGeneric';
function Event() {
    const { event } = useEventContext();
    if (isVisit(event)) {
        return React.createElement(EventVisit, null);
    }
    if (isGenericEvent(event)) {
        return React.createElement(EventGeneric, null);
    }
    return React.createElement(EventTimeOff, null);
}
export default Event;
